import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';

/**
 * Hook para obtener todos los usuarios
 * 
 * Usa React Query para cachear los datos y evitar llamadas duplicadas
 */
export const useUsers = () => {
  const { data: users = [], isLoading, error } = useQuery({
    queryKey: ['users'],
    queryFn: async () => {
      const httpClient = createHttpClient(apiClientWH);
      const response = await httpClient.get<any[]>('/users');
      return Array.isArray(response) ? response : [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  // 🎯 Función helper para obtener el nombre del usuario por ID
  const getUserName = (userId: number | undefined): string => {
    if (!userId) return '-';
    const user = users.find((u: any) => u.id === userId);
    return user?.name || String(userId);
  };

  return {
    users,
    isLoading,
    error,
    getUserName,
  };
};
